export const ACCESS_TOKEN_KEY = 'authToken'
export const ACCESS_TOKEN_EXP_KEY = 'authTokenExp'
export const USER_ID_KEY = 'authUserId'


let accessTokenMem: string | undefined
let accessExpMem: number | undefined
let userIdMem: number | undefined

const ss = typeof window !== 'undefined' ? window.sessionStorage : undefined

const ssGet = (k: string) => {
    try { return ss?.getItem(k) ?? null } catch { return null }
}
const ssSet = (k: string, v: string) => {
    try { ss?.setItem(k, v) } catch {}
}
const ssDel = (k: string) => {
    try { ss?.removeItem(k) } catch {}
}

export const setAccessInMemory = (token?: string, exp?: number) => {
    accessTokenMem = token
    accessExpMem = exp
}

export const hydrateAccessFromStorage = () => {
    const t = ssGet(ACCESS_TOKEN_KEY) ?? undefined
    const expStr = ssGet(ACCESS_TOKEN_EXP_KEY)
    const exp = expStr ? Number(expStr) : undefined
    const uidStr = ssGet(USER_ID_KEY)
    const uid = uidStr ? Number(uidStr) : undefined

    setAccessInMemory(t ?? undefined, exp)
    userIdMem = uid
}

export const setAccessToken = (t?: string, exp?: number) => {
    setAccessInMemory(t, exp)

    if (t) ssSet(ACCESS_TOKEN_KEY, t)
    else ssDel(ACCESS_TOKEN_KEY)

    if (exp != null) ssSet(ACCESS_TOKEN_EXP_KEY, String(exp))
    else ssDel(ACCESS_TOKEN_EXP_KEY)
}

export const getAccessToken = () =>
    accessTokenMem ?? (ssGet(ACCESS_TOKEN_KEY) ?? undefined) ?? undefined

export const getAccessTokenExp = () => {
    if (accessExpMem != null) return accessExpMem
    const v = ssGet(ACCESS_TOKEN_EXP_KEY)
    return v ? Number(v) : undefined
}

export const isAccessTokenExpired = (skewSec = 45) => {
    const exp = getAccessTokenExp()
    if (!exp) return true
    const now = Math.floor(Date.now() / 1000)
    return now >= (exp - skewSec)
}

export const setAuthUserId = (id?: number) => {
    userIdMem = id
    if (id != null) ssSet(USER_ID_KEY, String(id))
    else ssDel(USER_ID_KEY)
}

export const getAuthUserId = () => {
    if (userIdMem != null) return userIdMem
    const v = ssGet(USER_ID_KEY)
    return v ? Number(v) : undefined
}

export const clearAuth = () => {
    setAccessInMemory(undefined, undefined)
    accessTokenMem = undefined
    accessExpMem = undefined
    userIdMem = undefined

    ssDel(ACCESS_TOKEN_KEY)
    ssDel(ACCESS_TOKEN_EXP_KEY)
    ssDel(USER_ID_KEY)
}
